<template>
  <AdminLayout><AdminUsersTable /></AdminLayout>
</template>

<script>
import AdminLayout from '../AdminLayout.vue';
import AdminUsersTable from './AdminUsersTable.vue';

export default {
  name: 'AdminUsers',
  components: { AdminLayout, AdminUsersTable },
};
</script>
